import backend from '@common/backend';
import { ITableDataQuery } from '@common/models/TableData';

import { programFromBE } from './programs';

const BASE = '/rubrics';

export const getRubrics = async (query: any) => backend.get(`${BASE}/`, { params: query });

export const getRubricPrograms = async (query: ITableDataQuery) =>
	backend
		.get(`${BASE}/programs`, { params: query })
		.then((programs: any[]) => programs.map(programFromBE));

export const getRubric = async (rubricId: number) => backend.get(`${BASE}/${rubricId}`);

export const postRubric = async (data: any) => backend.post(`${BASE}`, data);

export const updateRubric = async (rubricId: number, data: any) =>
	backend.put(`${BASE}/${rubricId}`, data);

export const deleteRubric = async (rubricId: number) => backend.delete(`${BASE}/${rubricId}`);
